import "../css/BookInfo.css"; // Import the external CSS file

const BookInfo = ({ author }) => (
  <div className="book-info-container">
    <p className="book-author">{author}</p>
  </div>
);

export default BookInfo;
